export type Year = `${number}${number}${number}${number}`
export type Month = `${number}${number}`
type Day = `${number}${number}`
export type Hour = `${number}${number}`
export type Minute = `${number}${number}`
export type kapitelDateString = `${Year}-${Month}-${Day}`
export type kapitelTimeString = `${Hour}:${Minute}`;
export type kapitelDateTimeString = `${kapitelDateString}T${kapitelTimeString}:${number}${string}`;
export type kapitelMonthString = `${Year}-${Month}-01`
export type kapitelYearString = `${Year}-01-01`

// temporary until used by BE and auto-imported by GQLite
export enum JobsiteCategory {
    Alternative = 'ALTERNATIVE',
    Booked = 'BOOKED',
    Favorite = 'FAVORITE',
    // Blacklisted = 'BLACKLISTED',
    Other = 'OTHER'
}




